var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 24C18.5529 24 24 18.5647 24 12C24 5.44707 18.5411 0 11.9882 0C5.42347 0 0 5.44707 0 12C0 18.5647 5.43527 24 11.9999 24ZM11.9882 13.7647C11.3647 13.7647 11.0235 13.4 10.9999 12.7765L10.8353 6.96474C10.8117 6.31766 11.3058 5.85882 11.9764 5.85882C12.6352 5.85882 13.1411 6.32941 13.1176 6.97649L12.9529 12.7765C12.9293 13.4118 12.5764 13.7647 11.9882 13.7647ZM11.9882 18.0941C11.3058 18.0941 10.6705 17.5529 10.6705 16.8235C10.6705 16.0941 11.294 15.5529 11.9882 15.5529C12.6705 15.5529 13.3058 16.0823 13.3058 16.8235C13.3058 17.5647 12.6588 18.0941 11.9882 18.0941Z",
    fill: "#FF0000",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.fdfe6a21661134ec8ea40789939bf4e2.svg";
export { ForwardRef as ReactComponent };